import { BaseMoveError } from '../../errors/BaseMoveError'
import BoardNotFoundError from './BoardNotFoundError'

/**
 * Possible errors associated with a board move
 */
enum BoardMoveErrorTypes {
    FromBoard,
    ToBoard,
}

/**
 * Error thrown if an exception takes place whilst processing
 * a board move request.
 * Underlying error can be one of the following:
 * BoardNotFound -> For both source and destination boards
 * BoardNotFound -> For both source and destination boards
 */
class BoardMoveError extends BaseMoveError<
    BoardMoveErrorTypes,
    BoardNotFoundError
> {}

export { BoardMoveError, BoardMoveErrorTypes }
